/* MILLO GANG · navegación (Nira, 12-oct-2026). Sin librerías.
   Panel «Tienda»: se abre al pasar el ratón (o con la flecha abajo) y se cierra al salir, con Esc o con un clic fuera.
   Pulsar «Tienda» lleva directo a «Todo» (Edgar, 12-oct).
   Menú móvil a pantalla completa: atrapa el foco, Esc cierra y devuelve el foco al botón; la página no se mueve debajo.
   Al volver con «Atrás» (página restaurada del historial) los dos se cierran. */
(function(){
  var d = document, root = d.documentElement;
  var hd = d.querySelector('[data-mgn]'); if (!hd) return;
  var desk = window.matchMedia('(min-width: 981px)');

  /* ── panel «Tienda» ── */
  var btn = hd.querySelector('[data-mgn-shop]'), panel = d.getElementById('mgn-p'), scrim = d.querySelector('[data-mgn-scrim]');
  var li = btn ? btn.parentNode : null, open = false, tOpen = 0, tClose = 0, byHover = 0;
  function show(){
    if (open || !panel || !desk.matches) return;
    open = true; clearTimeout(tClose);
    panel.hidden = false; if (scrim) scrim.hidden = false;
    btn.setAttribute('aria-expanded', 'true'); hd.classList.add('is-open');
  }
  function hide(back){
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!open) return; open = false;
    panel.hidden = true; if (scrim) scrim.hidden = true;
    btn.setAttribute('aria-expanded', 'false'); hd.classList.remove('is-open');
    if (back) btn.focus();
  }
  if (btn && panel && li) {
    var todo = panel.querySelector('.mgn-cats a');
    btn.addEventListener('click', function(){
      if (todo) { location.href = todo.href; return; } /* «Tienda» = la colección entera */
      if (open && Date.now() - byHover < 700) return; /* abierto al pasar el ratón: ese mismo clic no lo cierra */
      if (open) hide(); else show();
    });
    btn.addEventListener('keydown', function(e){
      if (e.key !== 'ArrowDown') return;
      e.preventDefault(); show(); if (todo && open) todo.focus();
    });
    li.addEventListener('pointerenter', function(e){
      if (e.pointerType !== 'mouse' || !desk.matches) return;
      clearTimeout(tClose);
      if (!open) tOpen = setTimeout(function(){ show(); byHover = Date.now(); }, 80);
    });
    li.addEventListener('pointerleave', function(e){
      if (e.pointerType !== 'mouse') return;
      clearTimeout(tOpen);
      tClose = setTimeout(function(){ hide(false); }, 180);
    });
    li.addEventListener('focusout', function(e){ if (open && e.relatedTarget && !li.contains(e.relatedTarget)) hide(false); });
    if (scrim) scrim.addEventListener('click', function(){ hide(false); });
    d.addEventListener('click', function(e){ if (open && !li.contains(e.target)) hide(false); });
    d.addEventListener('keydown', function(e){ if (e.key === 'Escape' && open) { var inside = li.contains(d.activeElement); hide(inside); } });
  }

  /* «Avísame cuando salgan» desde abajo: sube al formulario y deja el cursor en el correo */
  [].slice.call(d.querySelectorAll('[data-mgn-focus]')).forEach(function(l){
    l.addEventListener('click', function(){
      var f = d.getElementById(l.getAttribute('data-mgn-focus'));
      if (f) setTimeout(function(){ try { f.focus({ preventScroll: true }); } catch(e){ f.focus(); } }, 450);
    });
  });

  /* ── menú móvil ── */
  var burger = hd.querySelector('[data-mgn-open]'), menu = d.getElementById('mgn-m');
  if (burger && menu) {
    var x = menu.querySelector('[data-mgn-close]');
    var focusables = function(){
      return [].slice.call(menu.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])'))
        .filter(function(el){ return el.offsetWidth || el.offsetHeight || el.getClientRects().length; });
    };
    var mOpen = function(){
      if (!menu.hidden) return;
      menu.hidden = false; burger.setAttribute('aria-expanded', 'true'); root.classList.add('mgn-lock');
      setTimeout(function(){ if (x) x.focus(); }, 20);
    };
    var mClose = function(back){
      if (menu.hidden) return;
      menu.hidden = true; burger.setAttribute('aria-expanded', 'false'); root.classList.remove('mgn-lock');
      if (back !== false) burger.focus();
    };
    burger.addEventListener('click', mOpen);
    if (x) x.addEventListener('click', function(){ mClose(); });
    menu.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { e.preventDefault(); mClose(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && d.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); }
    });
    /* la bolsa se abre por encima: el menú se cierra sin robarle el foco */
    [].slice.call(menu.querySelectorAll('.bagbtn')).forEach(function(b){ b.addEventListener('click', function(){ mClose(false); }); });
    /* un enlace a la misma página (o a un ancla) también cierra */
    [].slice.call(menu.querySelectorAll('a[href]:not(.bagbtn)')).forEach(function(a){
      a.addEventListener('click', function(){ if (a.pathname === location.pathname) mClose(false); });
    });
    var onBp = function(){ if (desk.matches) mClose(false); else hide(false); };
    if (desk.addEventListener) desk.addEventListener('change', onBp); else if (desk.addListener) desk.addListener(onBp);
  }

  /* al volver con «Atrás» el navegador restaura la página tal como se dejó: panel y menú, cerrados */
  window.addEventListener('pageshow', function(e){
    if (!e.persisted) return;
    hide(false);
    if (typeof mClose === 'function') mClose(false);
  });

  /* ── cabecera que se esconde al bajar y vuelve al subir (12-oct, Edgar) ──
     No se esconde: cerca de arriba, con el panel Tienda o el menú abiertos, con la bolsa abierta
     ni si el foco del teclado está dentro de la cabecera. Umbral de 6 px para que no tiemble. */
  var lastY = window.scrollY, ticking = false;
  function topH(){ var cs = getComputedStyle(root); return (parseFloat(cs.getPropertyValue('--ann')) || 0) + (parseFloat(cs.getPropertyValue('--hd')) || 0); }
  function canHide(){
    if (open) return false;
    if (menu && !menu.hidden) return false;
    if (root.classList.contains('pop-lock') || root.classList.contains('mgn-lock')) return false;
    if (hd.contains(d.activeElement)) return false;
    return true;
  }
  function onHd(){
    ticking = false;
    var y = Math.max(0, window.scrollY), dy = y - lastY;
    if (y <= topH() * 2) root.classList.remove('hd-hidden');
    else if (dy > 6 && canHide()) root.classList.add('hd-hidden');
    else if (dy < -6) root.classList.remove('hd-hidden');
    if (Math.abs(dy) > 6 || y <= 0) lastY = y;
  }
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(onHd); } }, {passive: true});
  hd.addEventListener('focusin', function(){ root.classList.remove('hd-hidden'); });

  /* pestañas de colección en el móvil (una fila que se desliza): la colección actual, a la vista */
  var pill = d.querySelector('.mgn-pills a[aria-current="page"]');
  if (pill && pill.parentNode.scrollWidth > pill.parentNode.clientWidth) {
    var pr = pill.parentNode;
    pr.scrollLeft += pill.getBoundingClientRect().left - pr.getBoundingClientRect().left - 16;
  }
})();
